var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgC = function SvgC(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.2,
    height: 46,
    viewBox: "0 0 38.2 45.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1 13.2a1.088 1.088 0 0 1-1.5 0 24.282 24.282 0 0 0-3.2-2.4 7.871 7.871 0 0 0-4.2-1.2 12.3 12.3 0 0 0-5.3 1.1 14.115 14.115 0 0 0-4 2.9 13.292 13.292 0 0 0-2.5 4.1 14.669 14.669 0 0 0 0 9.7 11.624 11.624 0 0 0 2.5 4.1 12.413 12.413 0 0 0 9.2 4 10.3 10.3 0 0 0 4.6-1 8.927 8.927 0 0 0 2.9-2.2 1.088 1.088 0 0 1 1.5 0l.1.1 5.6 6.1a1.087 1.087 0 0 1 0 1.5 28.317 28.317 0 0 1-2.8 2 19.975 19.975 0 0 1-4.2 1.9 18.9 18.9 0 0 1-4.1 1 19.529 19.529 0 0 1-3.4.3 25.662 25.662 0 0 1-9.1-1.6A21.163 21.163 0 0 1 1.9 31.9 22.768 22.768 0 0 1 0 22.6a24.822 24.822 0 0 1 1.8-9.3A21.163 21.163 0 0 1 14.1 1.6 25.662 25.662 0 0 1 23.2 0a23.006 23.006 0 0 1 8.2 1.6 17.346 17.346 0 0 1 6.5 4.2 1.087 1.087 0 0 1 0 1.5Z",
    fill: "#fff"
  })));
};

export default SvgC;